import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { LiraAdvContainer } from '@sbt-web/adv';
import { useIsVisible } from '@sbt-web/hooks';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
const observerOptions = {
  threshold: 0.01,
  rootMargin: '200px'
};
export const LiraLazySlotBelowAdView = () => {
  const $ = _c(12);
  const elementRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      observerOptions
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isVisible, setElement, unobserve] = useIsVisible(t0);
  let t1;
  let t2;
  if ($[1] !== setElement || $[2] !== unobserve) {
    t1 = () => {
      if (elementRef.current) {
        setElement(elementRef.current);
      }
      return () => {
        unobserve();
      };
    };
    t2 = [setElement, unobserve];
    $[1] = setElement;
    $[2] = unobserve;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== isVisible || $[6] !== unobserve) {
    t3 = () => {
      if (isVisible) {
        window.liraSDKQueue.push(_temp);
        unobserve();
      }
    };
    $[5] = isVisible;
    $[6] = unobserve;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleLazyLoad = t3;
  let t4;
  let t5;
  if ($[8] !== handleLazyLoad) {
    t4 = () => {
      handleLazyLoad();
    };
    t5 = [handleLazyLoad];
    $[8] = handleLazyLoad;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div ref={elementRef} className="adview-bottom"><LiraAdvContainer idForAd={LiraContainerIds.adView.bottom} style={{
        display: "block"
      }} /></div>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp() {
  window.liraSdk.fetchLazyLoadAd([LiraContainerIds.adView.bottom]);
}